"use strict";
/*
 * Created on 01 23 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 * @author Tomas Leity
 */


var NotificationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(NotificationConverter, _DataObjectConverter_);

  function NotificationConverter() {
    _classCallCheck(this, NotificationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotificationConverter).apply(this, arguments));
  }

  return NotificationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.NotificationConverter = NotificationConverter;